import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';

const ImageSliderMobile = ({ images, imgIndex, setImgIndex, matches }) => {
  const [loadedImages, setLoadedImages] = useState(Array(images.length).fill(false));
  const [firstImageLoaded, setFirstImageLoaded] = useState(false);

  const handleImageLoad = (index) => {
    setLoadedImages((prev) => {
      const newLoaded = [...prev];
      newLoaded[index] = true;
      return newLoaded;
    });
    if (index === 0) setFirstImageLoaded(true);
  };

  // 预加载其它图片
  useEffect(() => {
    if (firstImageLoaded) {
      images.forEach((image, index) => {
        if (!loadedImages[index]) {
          const img = new Image();
          img.src = image.replace('.tb', '');
          img.onload = () => handleImageLoad(index);
        }
      });
    }
  }, [firstImageLoaded, images, loadedImages]);

  return (
    <Swiper
      modules={[Navigation, Pagination, Scrollbar, A11y]}
      style={{
        '--swiper-navigation-color': 'rgba(255, 255, 255, 0.85)',
        '--swiper-navigation-size': '28px',
        '--swiper-scrollbar-drag-color': 'rgba(255, 255, 255, 0.5)',
        '--swiper-pagination-color': 'rgba(255, 255, 255, 0.7)',
      }}
      spaceBetween={20}
      slidesPerView={1}
      pagination={false}
      scrollbar={false}
      loop={false} // ✅ 非循环模式
      navigation={!matches}
      initialSlide={imgIndex} // 初始定位
      onSlideChange={(swiper) => setImgIndex(swiper.activeIndex + 1)}
    >
      {images.map((image, i) => (
        <SwiperSlide
          key={image + i}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            width: '100%',
            background: 'rgba(255, 255, 255, 0)',
            backdropFilter: 'blur(16px)',
          }}
        >
          <div
            style={{
              width: '85%',
              maxHeight: '85%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: '24px',
              overflow: 'hidden',
              boxShadow: loadedImages[i]
                ? '0 24px 48px rgba(0,0,0,0.16)'
                : '0 0 0 rgba(0,0,0,0)',
              transition: 'all 0.6s ease',
              background: loadedImages[i]
                ? 'transparent'
                : 'rgba(255, 255, 255, 0.1)',
              transform: loadedImages[i] ? 'scale(1)' : 'scale(0.95)',
            }}
          >
            <img
              loading="lazy"
              alt="图片加载中"
              src={i === 0 ? image.replace('.tb', '') : firstImageLoaded && image.replace('.tb', '')}
              onLoad={() => handleImageLoad(i)}
              style={{
                width: loadedImages[i] ? '100%' : 0,
                maxHeight: '100%',
                objectFit: 'cover',
                borderRadius: '24px',
                boxShadow: '0 12px 28px rgba(0,0,0,0.12)',
                transition: 'all 0.6s ease',
                opacity: loadedImages[i] ? 1 : 0,
              }}
            />
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default ImageSliderMobile;
